import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1c70aca8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header"
};
const _hoisted_2 = {
  class: "header_l"
};
const _hoisted_3 = {
  class: "header_t"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));
const _hoisted_5 = {
  class: "header_r"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode(_toDisplayString(_ctx.date) + " ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.d), 1), _createTextVNode(" " + _toDisplayString(_ctx.second), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, _toDisplayString($setup.appTitle), 1), _hoisted_4]), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", {
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => $setup.handleLinkHome && $setup.handleLinkHome(...args))
  }, [_createVNode(_component_Icon, {
    class: "out_icon",
    name: "icon-jinruxitong1",
    style: {
      "font-size": "22px"
    }
  }), _createTextVNode(" 管理平台 ")])])]);
}